<template>
  <div class="tab-content-area">
    <!-- アクティブなタブに応じてスロットコンテンツを表示 -->
    <div class="tab-panel">
      <slot :name="activeTab" />
    </div>
  </div>
</template>

<script setup>
/**
 * TabContentArea - タブコンテンツエリアコンポーネント (Organism)
 *
 * MoleculesとAtomsを組み合わせて作る、より具体的なタブコンテンツ表示領域です。
 *
 * 責務:
 * - タブに応じたコンテンツエリアの表示制御
 * - スロットによる柔軟なコンテンツ配置
 * - 統一されたタブパネルレイアウトの提供
 * - UIの描画に専念（ロジックは持たない）
 */

defineProps({
  /**
   * 現在アクティブなタブのキー
   */
  activeTab: {
    type: String,
    required: true
  }
})
</script>

<style scoped>
.tab-content-area {
  min-height: 200px;
}

.tab-panel {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
